import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getClientId = async () => {
  return userRequest.get(`${DOMAIN}/api/client/clientId`);
}

export const getClientCount = async () => {
  return userRequest.get(`${DOMAIN}/api/client/count`);
}

export const getClient = async () => {
    return userRequest.get(`${DOMAIN}/api/client`);
  };

export const getClientPermission = async (userId) => {
    return userRequest.get(`${DOMAIN}/api/client/client_permission?userId=${userId}`);
  };

export const getClientResume = async () => {
    return userRequest.get(`${DOMAIN}/api/client/client_resume`);
  };

export const getProvince = async () => {
    return userRequest.get(`${DOMAIN}/api/client/province`);
  };

export const getProvinceOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/client/provinceOne?id=${id}`);
  };

export const getProvinceClientOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/client/provinceClientOne?id_client=${id}`);
  };

export const getProvinceClient = async () => {
    return userRequest.get(`${DOMAIN}/api/client/provinceClient`);
  };

export const postProvince = async (data) => {
    return userRequest.post(`${DOMAIN}/api/client/province`, data);
  };

export const getClient_type = async () => {
  return userRequest.get(`${DOMAIN}/api/client/type_client`);
};

export const getClientOne = async (id) => {
  return userRequest.get(`${DOMAIN}/api/client/clientOne?id_client=${id}`);
};

export const postClient = async (data) => {
  return userRequest.post(`${DOMAIN}/api/client`, data);
};

export const putClient = async (id,data) => {
  return userRequest.put(`${DOMAIN}/api/client?id_client=${id}`, data);
};

export const estSupprimeClient = async (id) => {
  return userRequest.put(`${DOMAIN}/api/client/est_supprime?id=${id}`);
};
